<!--
 优化代码，以slot的形式去加载组件，不再支持动态组件
 降低耦合度
-->
<template lang="html">
  <section class="mock-page-router-wrapper" v-if="isPageShow">
    <!-- <transition name="mpr-ani"> -->
    <div :id="id" class="mpr-body">
      <!-- <component :is="routerName" :params="params"></component> -->
      <slot></slot>
    </div>
    <!-- </transition> -->
  </section>
</template>

<script>
// import {getGUID} from '@/utils/index'
import { getGUID } from '@/utils/index'
let instanceCount = 0
export default {
  data() {
    return {
      id: 'mockPageRouter_' + getGUID(),
      scrollTop: 0,
      isPageShow: false
    }
  },
  beforeCreate() {
    const u = location.href
    // 刷新页面，回退至旧路由
    if (u.indexOf('routerAction') > -1) {
      const { path, params, query, name } = this.$route
      delete query.routerAction
      delete query._x
      this.$router.replace({
        name,
        path,
        params,
        query: {
          ...query,
          _x: getGUID()
        }
      })
    }
    instanceCount++
  },
  props: {
    titleFrom: {
      type: String
    },
    titleTo: {
      type: String
    }
  },
  destroyed() {
    instanceCount--
    this.resetPageScroll()
  },
  watch: {
    $route(to) {
      if (to.query.hasOwnProperty('routerAction')) {
        if (instanceCount > 1) {
          console.warn(
            '当前页面存在多个mockRouterAction实例，请使用$refs.xxx.show()的方式'
          )
          return
        }
        this.show()
      } else {
        this.hide()
      }
    }
  },
  methods: {
    show() {
      this.isPageShow = true
      this.titleTo && this.$$title(this.titleTo)
      this.setPageScrollHidden()
    },
    hide() {
      this.isPageShow = false
      this.titleFrom && this.$$title(this.titleFrom)
      this.resetPageScroll(this.scrollTop)
    },
    setPageScrollHidden() {
      this.scrollTop = document.body.scrollTop
      document.body.scrollTop = 0
      document.body.classList.add('of-hide')
      document.documentElement.classList.add('of-hide')
    },
    resetPageScroll(scrollTop = 0) {
      document.body.classList.remove('of-hide')
      document.documentElement.classList.remove('of-hide')
      document.body.scrollTop = scrollTop
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.mock-page-router-wrapper {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
.mpr-body {
  flex: 1;
  overflow-y: auto;
}
.mpr-body--toggle {
  transform: translate(0);
  transition: transform 0.3s;
}
// .mpr-ani-enter-active,
// .mpr-ani-leave-active {
//   transform: translate(0);
//   transition: transform 0.6s;
// }
// .mpr-ani-enter,
// .mpr-ani-leave-to {
//   transform: translate(100%, 0);
// }
</style>
